<template>
  <div class="Popup-form chunky-form">
    <ProgressStepper
      :steps="stages"
    />

    <form
      autocomplete="off"
    >
      <div
        v-show="stage === 1"
        class="AuthRegister"
      >
        <h2 class="acc-modal-title font-heavy">
          Please register below
        </h2>
        <div
          v-if="!emailOnly"
          class="SocialAuth"
        >
          <social-account-auth-buttons
            :show-text-label="false"
            :import-comment="importComment"
            auth-type="register"
          />
          <div class="Authentication-divider">
            <span class="Authentication-text">
              OR
            </span>
          </div>
        </div>
        <p>Enter your details</p>
        <register-form
          :import-comment="importComment"
          :stage="1"
          no-redirect
          @register-form:success="handleRegisterFormEvent"
        />
      </div>
      <register-stage-personal-info
        v-show="stage === 2"
        :stage="2"
        @register-stage:success="nextStep"
      />
      <register-stage-job-preference
        v-show="stage === 3"
        :stage="3"
        @register-stage:success="nextStep"
      />
      <register-stage-job-roles
        v-show="stage === 4"
        :stage="4"
        @register-stage:success="nextStep"
      />
      <register-stage-diversity
        v-show="stage === 5 && diversityDataEnabled"
        :stage="5"
        is-modal-registration
        @register-stage:success="nextStep"
      />
      <register-stage-newsletter
        v-show="stage === 6"
        :stage="6"
        @register-stage:success="nextStep"
      />
      <p
        v-if="stage === 1"
        class="acc-login"
      >
        Already have an account?
        <a
          href="#"
          @click.prevent="switchToLogin"
        >
          <span>Login</span>
        </a>
      </p>
    </form>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import RegisterStageJobPreference from '@/components/authentication/register-page/stages/register-stage-job-preference';
import RegisterStageJobRoles from '@/components/authentication/register-page/stages/register-stage-job-roles.vue';
import ProgressStepper from '@/components/common/progress-stepper';
import RegisterForm from '@/components/authentication/forms/register-form';
import RegisterStagePersonalInfo from '@/components/authentication/register-page/stages/register-stage-personal-info';
import RegisterStageDiversity from '@/components/authentication/register-page/stages/register-stage-diversity';
import RegisterStageNewsletter from '@/components/authentication/register-page/stages/register-stage-newsletter';
import SocialAccountAuthButtons from '@/components/authentication/common/social-account-auth-buttons';
import ModalSaveItemMixin from '@/components/modal/mixins/modal-save-item-mixin';

export default {

  components: {
    RegisterStageJobPreference,
    ProgressStepper,
    RegisterStageDiversity,
    RegisterStageNewsletter,
    RegisterStagePersonalInfo,
    RegisterForm,
    SocialAccountAuthButtons,
    RegisterStageJobRoles,
  },

  mixins: [ModalSaveItemMixin],

  props: {
    emailOnly: {
      default: false,
      type: Boolean,
    },
    importComment: {
      default: null,
      type: String,
    },
  },

  data() {
    return {
      stage: 1,
      diversityDataEnabled: process.env.DIVERSITY_DATA_ENABLED,
    };
  },

  computed: {
    stages() {
      return [1, 2, 3,
        ...process.env.DIVERSITY_DATA_ENABLED ? [4] : [],
        5].map((stage, index) => {
        return {
          id: stage,
          isActive: this.stage === stage,
          isComplete: index < this.stage,
        };
      });
    },
  },

  // Lifecycle hooks
  mounted() {
    this.$gtag.send({
      event: 'register-modal-shown',
      action: 'show-modal',
    });
    this.getGenders();
  },

  methods: {
    ...mapActions('user', {
      registerUserViaModal: 'registerUser',
      updateUser: 'updateUser',
    }),
    ...mapActions('entities', {
      getGenders: 'getGenders',
    }),

    handleRegisterFormEvent() {
      if (this.shortListInfo !== null) {
        this.saveItemAfterRegistration();
      }

      this.nextStep({ stage: 1 });
    },

    nextStep(completedStage) {
      this.updateAnalytics({
        event: `register-modal-stage-${completedStage.stage}`,
        action: 'submit-success',
      });

      if (completedStage.stage === 5) {
        this.$bus.$emit('bus:global-modal:close');
        return;
      }

      if (completedStage.stage === 3 && !process.env.DIVERSITY_DATA_ENABLED) {
        this.stage = 5; // skip diversity stage
      } else {
        this.stage = completedStage.stage + 1;
      }
    },

    switchToLogin() {
      this.$bus.$emit('bus:authentication:show-login-form');
    },
  },
};
</script>
